import React from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { Modal } from '@/ui/index';
import {
  actions as cabinetActions,
  selectors as cabinetSelectors,
} from '@/domains/cabinet';
import CardShapes from '@/icons/CardShapes';
import SectionTitle from '@/ui/SectionTitle/SectionTitle';
import { PopUpLogin } from '@/ui/PopUpLogin/PopUpLogin';
import { PopUpOtp } from '@/ui/PopUpOtp/PopUpOtp';
import { PopUpList } from '@/ui/PopUpList/PopUpList';
import { PopUpConfirm } from '@/ui/PopUpConfirm/PopUpConfirm';
import { TariffPurchaseSteps } from '@/enums/cabinet';

import styles from './styles.module.scss';

export const TariffCardPopup = () => {
  const { tariffModal, selectedTariff, popUpStep, popUpConfirm } = useSelector(
    cabinetSelectors.selectCabinet,
  );

  const dispatch = useDispatch();
  const stepComponents = {
    [TariffPurchaseSteps.List]: <PopUpList />,
    [TariffPurchaseSteps.Login]: <PopUpLogin />,
    [TariffPurchaseSteps.Otp]: <PopUpOtp />,
  };
  return (
    <>
      {!popUpConfirm && tariffModal && (
        <Modal
          data-testid='tariffPurchaseModal'
          active={!popUpConfirm && tariffModal}
          setActive={() => {
            if (tariffModal) {
              dispatch(cabinetActions.setTariffModal(false));
              dispatch(cabinetActions.setPopUpStep(TariffPurchaseSteps.List));
            }
          }}
          className={styles.tariffModal}
          itemScope
          itemType='https://schema.org/Property'
          closeOnOutsideClick={popUpStep !== TariffPurchaseSteps.Otp}
        >
          <div>
            <div className={styles.backgroundWrapper}>
              <div className={styles.top}>
                <div className={styles.titleTop}>
                  <SectionTitle
                    titleModify={classNames(styles.title, 'title--large')}
                  >
                    {selectedTariff?.name}
                  </SectionTitle>
                  <div className={styles.rectangle}></div>
                </div>
                <div className={styles.priceContainer}>
                  <span className={styles.price}>{selectedTariff?.price} </span>
                  <div className={styles.text}>
                    <span>₼/{selectedTariff?.price_text}</span>
                  </div>
                  {/* {item?.bottom_text && (
            <div className={styles.profitableText}>{item.bottom_text}</div>
          )} */}
                </div>
              </div>
              <CardShapes />
            </div>
            {stepComponents[popUpStep]}
          </div>
        </Modal>
      )}

      <PopUpConfirm />
    </>
  );
};
